var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { InView } from '@airtel/air-design-system';
import { useState } from 'react';
import { View } from 'react-native';
export var WithInViewWrapper = Component => {
  var Wrapper = props => {
    var _props$withInViewWrap = props.withInViewWrapper,
      withInViewWrapper = _props$withInViewWrap === void 0 ? false : _props$withInViewWrap,
      _props$withInViewWrap2 = props.withInViewWrapperProps,
      withInViewWrapperProps = _props$withInViewWrap2 === void 0 ? {} : _props$withInViewWrap2,
      internalRef = props.internalRef,
      restProps = __rest(props, ["withInViewWrapper", "withInViewWrapperProps", "internalRef"]);
    var onUserAction = props.onUserAction;
    var _withInViewWrapperPro = withInViewWrapperProps.inViewTriggerOnce,
      inViewTriggerOnce = _withInViewWrapperPro === void 0 ? true : _withInViewWrapperPro,
      onItemVisibleMetaData = withInViewWrapperProps.onItemVisibleMetaData,
      enableLazyRender = withInViewWrapperProps.enableLazyRender;
    var _useState = useState(false),
      isInViewPort = _useState[0],
      setIsInViewPort = _useState[1];
    return _jsx(_Fragment, {
      children: withInViewWrapper ? _jsx(InView, Object.assign({
        triggerOnce: inViewTriggerOnce,
        onChange: inView => {
          if (inView) {
            setIsInViewPort(true);
            onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onItemVisibleMetaData, restProps));
          }
        }
      }, withInViewWrapperProps, {
        children: enableLazyRender ? isInViewPort ? _jsx(Component, Object.assign({}, restProps, {
          ref: internalRef
        })) : _jsx(View, {}) : _jsx(Component, Object.assign({}, restProps, {
          ref: internalRef
        }))
      })) : _jsx(Component, Object.assign({}, restProps, {
        ref: internalRef
      }))
    });
  };
  return Wrapper;
};